import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { IPolizaVitalicia } from 'src/app/shared/Entities/entities';
import { ProductService } from 'src/app/shared/services/product.service';

@Component({
  selector: 'app-tab-resumen',
  templateUrl: './tab-resumen.component.html',
  styleUrls: ['./tab-resumen.component.sass'],
})
export class TabResumenComponent implements OnInit, OnDestroy, OnChanges {
  @Input() idPoliza: string;
  // @Input() nombreProd: string;
  @Input() tipo: string;
  @Input() numPersona: string;
  @Output() getResumen$ = new EventEmitter();
  @Input() tabActive: boolean;
  @Output() getPrintData$ = new EventEmitter();
  loading = false;
  error = false;
  resumen: IPolizaVitalicia;
  private subscriptions: Subscription[] = [];
  constructor(private productService: ProductService) {}
  ngOnChanges() {
    this.sendPrintData();
  }
  sendPrintData() {
    if (this.tabActive) {
      this.getPrintData$.emit(this.print());
    }
  }
  print() {
    if (this.resumen) {
      return [
        {
          type: 'logo',
          content: {
            halign: 'right',
          },
        },
        {
          type: 'title',
          content: {
            text: `RESUMEN ${this.resumen.TipoPension}`,
            halign: 'left',
          },
        },
        {
          type: 'table',
          width: 100,
          content: {
            size: {
              columns: [15, 20, 15, 20, 15, 15],
            },
            table: [
              [
                { value: 'Número de póliza', type: 'header' },
                { value: this.resumen.Numero },
                { value: 'Fecha recepción de prima', type: 'header' },
                {
                  value: moment(
                    this.resumen.FechaRecepcionPrima,
                    'DD-MM-YYYY'
                  ).format('DD-MM-YYYY'),
                },
                { value: 'Inicio de póliza', type: 'header' },
                {
                  value: moment(
                    this.resumen.FechaInicioPoliza,
                    'DD-MM-YYYY'
                  ).format('DD-MM-YYYY'),
                },
              ],
              [
                { value: 'Invalidez', type: 'header' },
                {
                  value: moment(this.resumen.Invalidez, 'DD-MM-YYYY').format(
                    'DD-MM-YYYY'
                  ),
                },
                { value: 'Tipo de Pensión', type: 'header' },
                { value: this.resumen.TipoPension },
                { value: 'Renta mensual UF', type: 'header' },
                {
                  value: this.resumen.RentaMensual,
                },
              ],
              [
                { value: 'AFP de origen', type: 'header' },
                {
                  value: this.resumen.Afp,
                },
                { value: 'Monto de salud', type: 'header' },
                {
                  value: this.resumen.MontoSalud,
                },
                { value: 'Tipo de renta', type: 'header' },
                { value: this.resumen.TipoRenta },
              ],
              // [
              //   { value: 'Institutcion de salud', type: 'header' },
              //   { value: this.resumen.Isapre },
              //   { value: 'Meses diferidos', type: 'header' },
              //   { value: this.resumen.MesesDiferidos },
              //   { value: 'Ultimo pago pension', type: 'header' },
              //   {
              //     value: moment(this.resumen.PeriodoUltimoPago).format(
              //       'DD-MM-YYYY'
              //     )
              //   }
              // ],
              // [
              //   { value: 'Modalidad', type: 'header' },
              //   { value: this.resumen.ModalidadRenta },
              //   { value: 'Forma de pago', type: 'header' },
              //   { value: this.resumen.FormaPago },
              //   { value: 'Meses garantizados', type: 'header' },
              //   { value: this.resumen.MesesGarantizado }
              // ],
              // [
              //   { value: 'Cuenta Bancaria', type: 'header' },
              //   { value: this.resumen.CuentaBancaria },
              //   { value: 'Periodicidad de pago', type: 'header' },
              //   { value: this.resumen.Periodicidad },
              //   { value: 'Fecha proximo pago', type: 'header' },
              //   {
              //     value: moment(this.resumen.FechaProximoPago).format(
              //       'DD-MM-YYYY'
              //     )
              //   }
              // ],
              // [
              //   { value: 'Prima total recibida', type: 'header' },
              //   { value: this.resumen.PrimaTotalRecibida }
              // ]
            ],
          },
        },
      ];
    }
  }
  ngOnInit() {
    this.loading = true;
    this.error = false;
    const getDescargaPolizaSubs = this.productService
      .getDetalleVitalicia(this.idPoliza, this.tipo, this.numPersona)
      .subscribe(
        data => {
          this.loading = false;
          this.resumen = data;
          this.getResumen$.emit(this.resumen);
        },
        error => {
          this.loading = false;
          this.error = true;
        }
      );
    this.subscriptions.push(getDescargaPolizaSubs);
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
